module.exports = __webpack_public_path__ + "static/media/enabledDashboardIcon.ad89424a.svg";